import { AddRounded, EastRounded, StoreOutlined } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { size } from "lodash";
import PropTypes from "prop-types";
import { Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Flx from "../../../../../components/layout/Flx";
import LoadingFallback from "../../../../../components/LoadingFallback";
import TitledCard from "../../../../../components/ui/TitledCard";
import LoanPropertiesMinimalTable from "../../LoanDrilldownPropertiesTab/LoanPropertiesMinimalTable";
import { sidebarTypeToggle } from "../../../../../redux/actions/sidebarActions";
import { loanDrilldownSidebarTypes } from "../../../../../constants/enums/loanDrilldownScreenSidebarOptions";

const SummaryTabPropertiesCard = ({ baseUrl }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <TitledCard
      title={`Properties (${size(loanDrilldown?.subjectProperties)})`}
      icon={<StoreOutlined />}
      cardSx={{ flexBasis: "400px", flexGrow: 1, flexShrink: 0 }}
      variant="h3"
      headerEndContent={
        <Tooltip title="Add New Property" disableInteractive>
          <IconButton
            size="small"
            onClick={() =>
              dispatch(
                sidebarTypeToggle(loanDrilldownSidebarTypes.ADD_PROPERTY)
              )
            }
            sx={{ position: "absolute", right: 16, top: 16 }}
          >
            <AddRounded className="thin" />
          </IconButton>
        </Tooltip>
      }
      spl
      spr
      spb
    >
      <Suspense fallback={<LoadingFallback />}>
        <LoanPropertiesMinimalTable
          rowData={loanDrilldown?.subjectProperties}
          height={"200px"}
        />
      </Suspense>
      <Flx end fw sx={{ p: 2 }}>
        <Button
          variant="text"
          onClick={() => navigate(`${baseUrl}/properties`)}
          endIcon={<EastRounded className="thin" />}
        >
          Go to Properties
        </Button>
      </Flx>
    </TitledCard>
  );
};

SummaryTabPropertiesCard.propTypes = {
  baseUrl: PropTypes.string.isRequired,
};

export default SummaryTabPropertiesCard;
